export function usesNudgeV2(target: unknown, email: unknown): boolean {
  return target === 'behamicsSample' || email === 'dummy@behamics.com';
}
